// utils/correoCliente.js — cómo se MUESTRA el correo de un cliente en el POS (T2b, 23-sep).
// Las direcciones sintéticas del POS (sin-correo@pos.local, {cedula}@pos.local,
// {celular}@pos.local) NO son correos reales del cliente: existen solo porque Woo
// exige un email para crear el customer. Nunca se muestran como su correo — en su
// lugar «Sin correo». El dato en Woo NO cambia; esto es solo presentación.

export function esCorreoSintetico(email) {
  return String(email == null ? '' : email).trim().toLowerCase().endsWith('@pos.local');
}

// Qué mostrar como correo del cliente: el real, o «Sin correo» si está vacío o es
// sintético. Se renderiza SIEMPRE (no condicional): un cliente sin correo lo dice.
export function correoParaMostrar(email) {
  const e = String(email == null ? '' : email).trim();
  return (!e || esCorreoSintetico(e)) ? 'Sin correo' : e;
}
